/* Installable web app: captures the install prompt, shows a "Get the app" bar on phones,
   and powers the footer "Download the app" buttons (window.tmcInstall). */
(() => {
  if (window.__tmcApp) return;
  window.__tmcApp = true;
  const standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  if (standalone) document.documentElement.classList.add('tmc-standalone');
  const ua = navigator.userAgent;
  const isIOS = /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
  let deferred = null;

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferred = e;
    document.documentElement.classList.add('tmc-can-install');
  });

  const help = (platform) => {
    document.querySelector('.tmc-app-help')?.remove();
    const steps = platform === 'ios'
      ? ['Open thebombaywave.com in <b>Safari</b>', 'Tap the <b>Share</b> button (square with an arrow)', 'Choose <b>Add to Home Screen</b>, then <b>Add</b>']
      : ['Open thebombaywave.com in <b>Chrome</b>', 'Tap the <b>&#8942;</b> menu at the top right', 'Choose <b>Install app</b> or <b>Add to Home screen</b>'];
    const d = document.createElement('div');
    d.className = 'tmc-app-help';
    d.setAttribute('role', 'dialog');
    d.setAttribute('aria-modal', 'true');
    d.innerHTML = `<div class="tmc-app-help__box"><button type="button" class="tmc-app-help__close" aria-label="Close">&times;</button>
      <p class="tmc-app-help__title">Install the Bombay Wave app on ${platform === 'ios' ? 'iPhone' : 'Android'}</p>
      <ol>${steps.map((s) => `<li>${s}</li>`).join('')}</ol>
      <p class="tmc-app-help__note">It opens full screen from your home screen, like any other app.</p></div>`;
    d.addEventListener('click', (e) => { if (e.target === d || e.target.closest('.tmc-app-help__close')) d.remove(); });
    document.body.appendChild(d);
  };

  window.tmcInstall = async (platform) => {
    if (standalone) return;
    if (platform !== 'ios' && deferred) {
      deferred.prompt();
      await deferred.userChoice.catch(() => null);
      deferred = null;
      return;
    }
    help(platform);
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-tmc-install]');
    if (!b) return;
    e.preventDefault();
    window.tmcInstall(b.dataset.tmcInstall);
  });

  /* Bottom bar on phones (not inside the app, hidden 14 days after closing). */
  if (standalone || !window.matchMedia('(max-width: 749px)').matches) return;
  const KEY = 'tmc_app_prompt_dismissed';
  try { if (Date.now() - Number(localStorage.getItem(KEY) || 0) < 14 * 864e5) return; } catch (e) {}
  const show = (mode) => {
    if (document.querySelector('.tmc-app-bar')) return;
    const icon = document.querySelector('link[rel="apple-touch-icon"]')?.href || '';
    const bar = document.createElement('div');
    bar.className = 'tmc-app-bar';
    bar.setAttribute('role', 'dialog');
    bar.setAttribute('aria-label', 'Install the Bombay Wave app');
    bar.innerHTML =
      `<img src="${icon}" alt="" width="44" height="44">` +
      '<div class="tmc-app-bar__text"><strong>Get the Bombay Wave app</strong><span>' +
      (mode === 'ios' ? 'Tap <b>Share</b> then <b>Add to Home Screen</b>' : 'Faster shopping, one tap from your home screen') +
      '</span></div>' +
      (mode === 'ios' ? '' : '<button type="button" class="tmc-app-bar__install">Install</button>') +
      '<button type="button" class="tmc-app-bar__close" aria-label="Close">&times;</button>';
    document.body.appendChild(bar);
    requestAnimationFrame(() => bar.classList.add('is-open'));
    bar.querySelector('.tmc-app-bar__close').addEventListener('click', () => {
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
      bar.remove();
    });
    bar.querySelector('.tmc-app-bar__install')?.addEventListener('click', async () => {
      await window.tmcInstall('android');
      bar.remove();
    });
  };
  window.addEventListener('beforeinstallprompt', () => setTimeout(() => show('install'), 6000));
  window.addEventListener('appinstalled', () => document.querySelector('.tmc-app-bar')?.remove());
  if (isIOS) setTimeout(() => show('ios'), 6000);
})();
